import React from "react";
import { Box, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { styles } from "system/query/QueryUtility";

export interface QueryBuilderDropTargetProps {
  children?: ReactNode;
  isOver?: boolean;
  hasContentsAbove?: boolean;
  borderColor: string;
  onClick?: (event: React.MouseEvent) => void;
}

export function QueryBuilderDropTarget(props: QueryBuilderDropTargetProps): JSX.Element {
  const theme = useTheme();
  const { i18n } = useTranslation();

  const bg = props.isOver ? theme.palette.background.default : theme.colors.namedColors.dropBackgroundColor;

  const modStyles:any = {};
  if (props.hasContentsAbove) {
    modStyles.borderTop = `none`;
    modStyles.borderTopLeftRadius = 0;
    modStyles.borderTopRightRadius = 0;
  }

  return (
    <Box sx={{
        position:'relative',
        padding: '3px 0',
        fontSize: '0.8rem',
        border: `1px dashed ${props.borderColor}`,
        borderRadius: styles.boxBorderRadius,
        backgroundColor: bg,
        color: theme.palette.text.secondary,
        width: '300px',
        maxWidth: '100%',
        fontWeight:'bold',
        textAlign:'center',
        opacity: props.isOver ? 1 : 0.8,
        cursor:props.onClick ? 'pointer' : 'default',
        "&&:hover": {
          backgroundColor: props.onClick ? theme.palette.background.default : bg,
          opacity: props.onClick ? 1 : 0.8,
          color: props.onClick ? theme.palette.text.primary : theme.palette.text.secondary,
        },
        ...modStyles
      }}
      onClick={(event) => {if (props.onClick) props.onClick(event)}} >
      {i18n.t("query-form.drop-target")}
      {props.children}
    </Box>
  );
}